import { render } from "./Tokens.vue?vue&type=template&id=5a2f485b&scoped=true"
import script from "./Tokens.vue?vue&type=script&lang=js"
export * from "./Tokens.vue?vue&type=script&lang=js"

import "./Tokens.vue?vue&type=style&index=0&id=5a2f485b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2f485b"]])

export default __exports__